import { defineMessages } from 'react-intl';

/**
 * User-facing copy for the T2med launch lifecycle. Keys are extracted by
 * the Hyperlocalise/Crowdin pipeline (`i18n-pipeline.yml`).
 */
export const t2medMessages = defineMessages({
  launchResumedTitle: {
    id: 'x33PbLknDB',
    defaultMessage: 'Consult resumed from T2med',
  },
  launchReadyTitle: {
    id: '7QEibqg5pe',
    defaultMessage: 'Consult started from T2med',
  },
  launchRejectedTitle: {
    id: 'lNS8zfTp6r',
    defaultMessage: 'T2med launch failed',
  },
  launchRejectedNoOnboarding: {
    id: 'i8FviTXMIu',
    defaultMessage:
      'Connect T2med in Settings → EMR integrations, then launch again from T2med.',
  },
  launchRejectedGeneric: {
    id: 'ShuJGpuhz3',
    defaultMessage:
      'Heidi could not verify the T2med launch. Please launch again from T2med.',
  },
  launchTokenExpiredTitle: {
    id: '5ukmYPZlAr',
    defaultMessage: 'T2med connection expired',
  },
  launchTokenExpiredBody: {
    id: 'UUKuRkcpri',
    defaultMessage:
      'The T2med session token has expired (4-hour limit). Notes will be sent to T2med after you launch Heidi from T2med again.',
  },
  patientResolveFailedTitle: {
    id: '2XUTUHQ0EF',
    defaultMessage: 'Patient details unavailable',
  },
  patientResolveFailedBody: {
    id: 'hYq2RDVsYA',
    defaultMessage:
      'Heidi could not read the patient record from T2med. The consult still works — you can add patient details manually.',
  },
  writebackSkippedTitle: {
    id: '1MDa30jYwx',
    defaultMessage: 'Note not sent to T2med',
  },
  writebackSkippedBody: {
    id: '960iFj6pA2',
    defaultMessage:
      'Launch this patient from T2med again so Heidi can transfer the note.',
  },
  writebackPendingTitle: {
    id: 'hBUgtrgFL8',
    defaultMessage: 'Sending note to T2med',
  },
  writebackSucceededTitle: {
    id: 'h8jY4YJa9O',
    defaultMessage: 'Note sent to T2med',
  },
  writebackFailedTitle: {
    id: 'f8zH9qoZOa',
    defaultMessage: 'Could not send note to T2med',
  },
  writebackFailedValidation: {
    id: 'H9xT8Dy4az',
    defaultMessage: 'T2med rejected this note. Check the diagnoses and send it again.',
  },
  writebackFailedApiKey: {
    id: 'G9m/kZZFVN',
    defaultMessage:
      'T2med rejected the connection key. Check the key in T2med and launch again.',
  },
  writebackFailedKontext: {
    id: '7NrJhdxcw4',
    defaultMessage: 'The T2med session expired. Launch this patient from T2med again.',
  },
  writebackFailedProfile: {
    id: 'AKIYszv8j0',
    defaultMessage: 'This T2med version does not support this note type.',
  },
  writebackFailedNetwork: {
    id: '8WcpuDCjr5',
    defaultMessage: 'T2med was unavailable. Send the note again.',
  },
  writebackFailedGeneric: {
    id: 'NHdaTjE9EM',
    defaultMessage:
      'Heidi could not send this note to T2med. Send it again after checking the note.',
  },
});
